import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CDNIllustration from './cdn-illustration.js';
import Copy from './copy.js';
import Icon from './icon.js';
import { StandardCard } from './standard-card.js';
import styled from 'styled-components';
const ProgressBarContainer = styled.div.withConfig({ displayName: "brc-ProgressBarContainer", componentId: "brc-ly047w" }) `
  align-items: center;
  display: flex;

  ${Copy} {
    margin-left: 16px;
  }
`;
const ProgressBarBackground = styled.div.withConfig({ displayName: "brc-ProgressBarBackground", componentId: "brc-bukny4" }) `
  background-color: ${({ theme }) => theme.neutral200};
  border-radius: 6px;
  height: 10px;
  width: 152px;
`;
const Progress = styled.div.withConfig({ displayName: "brc-Progress", componentId: "brc-1clnbuc" }) `
  background-color: ${({ theme }) => theme.neutral400};
  border-radius: inherit;
  height: 100%;
  width: ${({ percentComplete }) => `${percentComplete}%`};
`;
const ProgressBar = ({ maxSteps, stepsComplete }) => {
    const hasReachedMaxSteps = maxSteps === stepsComplete;
    const percentComplete = (stepsComplete / maxSteps) * 100;
    return (_jsxs(ProgressBarContainer, { children: [_jsx(ProgressBarBackground, { children: _jsx(Progress, { percentComplete: percentComplete }) }), _jsx(Copy, Object.assign({ light: true, size: "xs" }, { children: `${stepsComplete}/${maxSteps} complete${hasReachedMaxSteps ? '!' : ''}` }))] }));
};
const StyledSection = styled.div.withConfig({ displayName: "brc-StyledSection", componentId: "brc-1ht1mbf" }) `
  align-items: center;
  border: solid 1px ${({ theme }) => theme.border};
  border-radius: 4px;
  display: flex;
  padding: 8px;
  justify-content: space-between;
  cursor: pointer;

  ${Copy} {
    flex: 1;
  }
`;
const leftIconSize = '54px';
const LeftIconContainer = styled.div.withConfig({ displayName: "brc-LeftIconContainer", componentId: "brc-1dlq6sy" }) `
  align-items: center;
  color: ${({ theme }) => theme.neutral400};
  display: flex;
  justify-content: center;
  height: ${leftIconSize};
  width: ${leftIconSize};
  margin-right: 8px;
  background-color: ${({ theme }) => theme.mermaidGreen200};
  border-radius: 50%;
`;
const Section = ({ onClick, copy, iconName }) => (_jsxs(StyledSection, Object.assign({ onClick: onClick }, { children: [_jsx(LeftIconContainer, { children: _jsx(Icon, { name: iconName }) }), _jsx(Copy, Object.assign({ bold: true }, { children: copy })), _jsx(Icon, { name: "actions/carrot-right" })] })));
const Plant = styled(CDNIllustration).withConfig({ displayName: "brc-Plant", componentId: "brc-1c4flc4" }) `
  height: 90px;
  min-width: 90px;
  width: 90px;
`;
const SectionsContainer = styled.div.withConfig({ displayName: "brc-SectionsContainer", componentId: "brc-vumghv" }) `
  margin-top: 32px;
  display: grid;
  grid-gap: 8px;
`;
const TextContainer = styled.div.withConfig({ displayName: "brc-TextContainer", componentId: "brc-vwrcdj" }) `
  display: flex;

  ${Plant} {
    margin-right: 8px;
  }

  margin-bottom: 16px;
`;
export const SeedsOfFinancing = ({ actionText, copy, imageFileName, maxSteps, onAction, stepsComplete, sections = [], title, }) => {
    return (_jsxs(StandardCard, { children: [_jsxs(TextContainer, { children: [_jsx(Plant, { filename: imageFileName }), _jsxs("div", { children: [_jsx(StandardCard.Header, { title: title }), _jsx(Copy, Object.assign({ light: true }, { children: copy }))] })] }), _jsx(ProgressBar, { maxSteps: maxSteps, stepsComplete: stepsComplete }), !!sections.length && _jsx(SectionsContainer, { children: sections }), _jsx(StandardCard.Footer, { actionText: actionText, onAction: onAction })] }));
};
SeedsOfFinancing.Section = Section;
export default SeedsOfFinancing;
//# sourceMappingURL=seeds-of-financing.js.map